<template>
  <div>
    <v-card class="secondary lighten-1">
      <v-card-title class="justify-center">
        <div class="title white--text">
          Successful transaction
          <v-icon class="ml-3">mdi-check-circle</v-icon>
        </div>
      </v-card-title>
      <v-card-text class="white--text justify-center">
        <div>
          <ul>
            <li>Amount: 500 EUR</li>
            <li>Fee: 0</li>
            <li>HEj</li>
            <li>HEj</li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Receipt'
}
</script>

<style lang="scss" scoped>

</style>